// e.g. src/container/profile/.../sod/authorized-filers/index.js
import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthorizedFilerDetails from './details';

const AuthorizedFilers = React.lazy(() => import('./authorizedfilers'));
// const AuthorizedFilerDetails = React.lazy(() => import('./details'));

const SODAuthorizedFilers = () => (
  <Suspense fallback={<div className="loading" />}>
    <Routes>
      <Route path="/" element={<Navigate to="list" replace />} />
      <Route path="list" element={<AuthorizedFilers />} />
      <Route path="details" element={<AuthorizedFilerDetails />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  </Suspense>
);

export default SODAuthorizedFilers;
